<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead />

    <!-- 셀프북 정산 내역 START -->
    <div class="calculate_detail">
      <div class="section full">
        <div class="inner">
          <!-- TODO: @STAN WHEN USER HAS NOT REGISTERED AS A SELLER, SHOW THIS -->
          <div v-if="!user.approvedSeller" class="empty">
            <div class="empty_title">
              <h2>{{ $t('views.member.selfbooksales.9652') }}</h2>
            </div>
            <div class="btn_wrap">
              <router-link :to="{ name: 'agree_to_terms' }" class="box_btn">
                <span class="an_t">{{
                  $t('views.member.selfbooksales.5080')
                }}</span>
              </router-link>
            </div>
          </div>

          <div v-if="user.approvedSeller" class="amount_wrap">
            <h3 class="sub_tit">{{ $t('views.member.selfbooksales.5738') }}</h3>
            <p>
              <span class="blind">{{
                $t('views.member.selfbooksales.6687')
              }}</span>
              <strong>
                <vue-intl-numberformat
                  locale="ko-KR"
                  class="price"
                  format-style="currency"
                  :currency="getCurrency.currency"
                  :number="user.currentFunds"
                />
              </strong>
            </p>
            <div class="amount_date">
              <p>
                {{ $t('views.member.selfbooksales.546')
                }}<span class="year">{{ lastPayoutDate }}</span>
              </p>
              <p>
                {{ $t('views.member.selfbooksales.6758')
                }}<span class="year">{{ lastPayoutRequestDate }}</span>
              </p>
            </div>
            <div class="btn_wrap">
              <router-link :to="{ name: 'request_payout' }" class="box_btn">
                <span class="an_t">{{
                  $t('views.member.selfbooksales.9697')
                }}</span>
              </router-link>
            </div>
            <p class="guide_txt">{{ $t('views.member.selfbooksales.1700') }}</p>
          </div>
        </div>
      </div>

      <div v-if="user.approvedSeller" class="section fill">
        <div class="inner">
          <div class="box">
            <h3 class="sub_tit">{{ $t('views.member.selfbooksales.7789') }}</h3>
            <div class="box_inner">
              <!-- 신청 내역이 없는 경우 strong 부분은 “ - ”로 제공 -->
              <dl>
                <dt>{{ $t('views.member.selfbooksales.6793') }}</dt>
                <dd>
                  <strong class="volume">{{ salesCount }}</strong>
                  <span class="currency">{{ $t('common.ui.bookcount') }}</span>
                </dd>
                <dt>{{ $t('views.member.selfbooksales.7855') }}</dt>
                <dd>
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="currency"
                      :currency="getCurrency.currency"
                      :number="salesTotal"
                    />
                  </strong>
                </dd>
                <dt>{{ $t('views.member.selfbooksales.8507') }}</dt>
                <dd>
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="currency"
                      :currency="getCurrency.currency"
                      :number="remainingBalance"
                    />
                  </strong>
                </dd>
              </dl>
              <dl>
                <dt>{{ $t('views.member.selfbooksales.3656') }}</dt>
                <dd>
                  <strong class="volume">{{ forSaleCount }}</strong>
                  <span class="currency">{{ $t('common.ui.bookcount') }}</span>
                </dd>
                <dt>{{ $t('views.member.selfbooksales.443') }}</dt>
                <dd>
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="currency"
                      :currency="getCurrency.currency"
                      :number="awaitingPayment"
                    />
                  </strong>

                  <p class="t_date">
                    {{ $t('views.member.selfbooksales.9601')
                    }}<span class="year">{{ currentPaymentRequestDate }}</span>
                  </p>
                </dd>
              </dl>
            </div>
            <p class="guide_txt">{{ $t('views.member.selfbooksales.2362') }}</p>
          </div>

          <div class="box">
            <h3 class="sub_tit">{{ $t('views.member.selfbooksales.5954') }}</h3>
            <ul class="total_history">
              <!-- TODO: @STAN Max # of 5 items at a time -->
              <li
                v-for="(payout, id) in payouts"
                :key="id"
                :class="payout.completed ? 'pay_done' : 'pay_ing'"
              >
                <div class="cell">
                  <span class="c_icon"></span>
                  <span class="year">{{ payout.date }}</span>
                </div>
                <div class="cell">
                  <p class="row">
                    <strong>
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="getCurrency.currency"
                        :number="payout.amount"
                      />
                    </strong>
                  </p>
                  <p class="row">
                    <span class="year">{{ payout.date }} </span>
                    <span
                      v-if="!payout.completed"
                      class="calc_state oneSpace"
                      >{{ $t('views.member.selfbooksales.9850') }}</span
                    >
                    <span v-if="payout.completed" class="calc_state oneSpace">{{
                      $t('views.member.selfbooksales.8858')
                    }}</span>
                  </p>
                </div>
              </li>
            </ul>
            <div class="board_pagemove_wrap">
              <div class="board_pagemove">
                <a href="javascript:void(0)" class="first"
                  ><span>{{ $t('common.ui.first') }}</span></a
                >
                <a href="javascript:void(0)" class="prev"
                  ><span>{{ $t('common.ui.previous') }}</span></a
                >
                <ul>
                  <li class="on"><a href="javascript:void(0)">1</a></li>
                  <li><a href="javascript:void(0)">2</a></li>
                  <li><a href="javascript:void(0)">3</a></li>
                  <li><a href="javascript:void(0)">4</a></li>
                  <li><a href="javascript:void(0)">5</a></li>
                  <li><a href="javascript:void(0)">6</a></li>
                  <li><a href="javascript:void(0)">7</a></li>
                  <li><a href="javascript:void(0)">8</a></li>
                  <li><a href="javascript:void(0)">9</a></li>
                  <li><a href="javascript:void(0)">10</a></li>
                </ul>
                <a href="javascript:void(0)" class="next"
                  ><span>{{ $t('common.ui.next') }}</span></a
                >
                <a href="javascript:void(0)" class="end"
                  ><span>{{ $t('views.member.selfbooksales.4015') }}</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 셀프북 판매량 START -->
    <!-- TODO: @Stan: using same saleschart as SelfbookDetail -->
    <SalesChart v-if="user.approvedSeller" :chart-data="chartData" />
  </div>
</template>

<script>
import SalesChart from '@/components/selfbook/SalesChart.vue'
import AccountHead from '@/components/member/AccountHead.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'SelfbookSales',

  components: {
    AccountHead,
    SalesChart
  },

  data() {
    return {
      user: {
        approvedSeller: true,
        currentFunds: 3240000
      },
      lastPayoutRequestDate: '2012.03.10',
      lastPayoutDate: '2012.03.20',
      salesCount: 5,
      salesTotal: 100000,
      remainingBalance: 500000,
      forSaleCount: 8,
      awaitingPayment: 500000,
      currentPaymentRequestDate: '2012.05.20',

      payouts: [
        {
          amount: 500000,
          date: '2020-01-25',
          completed: false
        },
        {
          amount: 100000,
          date: '2020-01-25',
          completed: false
        },
        {
          amount: 50000,
          date: '2020-01-25',
          completed: true
        },
        {
          amount: 15000,
          date: '2020-01-25',
          completed: true
        }
      ],
      chartData: {
        monthlySales: [
          { date: '12.02.20', count: 5 },
          { date: '12.02.20', count: 5 }
        ],
        // TODO: Year filter should be calculated server side
        // This is just temp data
        // Available years should start at 2020 and go to current year
        years: [2020, 2021],
        filters: ['판매량', '판매 금액'],
        salesCount: 123,
        salesPrice: 456
      }
    }
  },

  computed: {
    ...mapGetters(['getCurrency'])
  }
}
</script>

<style lang="scss" scoped>
.oneSpace {
  margin-left: 5px;
}
</style>
